import { getInfoCustomer } from '@/features/auth/services'
import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { useCartStore } from './cart'
import { useWishlistStore } from './wishlist'
import { useCompareStore } from './compare'

interface AccountState {
  data: ICustomerInfo
  isAuthenticated: boolean
  isLoading?: boolean
  setUser: (data: any) => void
  clearUser: () => void
  updateUser: () => Promise<void>
}
const initialState = {} as ICustomerInfo
export const useAccountStore = create<AccountState>()(
  devtools(
    persist(
      (set, get) => ({
        data: initialState,
        isAuthenticated: false,
        isLoading: false,
        setUser: async (data) => {
          set(() => ({ data: data, isAuthenticated: !!data && Object.keys(data).length > 0, isLoading: false}))
        },
        clearUser: () => {
          set(() => ({ data: initialState, isAuthenticated: false, isLoading: false }))
          if (Object.keys(get().data)) {
            useCartStore.getState().clearUserCart()
            useWishlistStore.getState().clearWishlist()
            useCompareStore.getState().clearCompareList()
          }
        },
        updateUser: async () => {
          set(() => ({ isLoading: true }))
          const res = await getInfoCustomer()
          set(() => ({ data: res, isAuthenticated: !!res && Object.keys(res).length > 0 }))
          set(() => ({ isLoading: false }))
        },
      }),
      {
        name: 'account-storage',
      }
    )
  )
)
